import { CustomerInlineInput } from './CustomerInlineInput'
import React from 'react'
import type { Customer } from '@ztechapps/common.contract'
import { buildUpdateCustomerCompanyNameQuery } from '@ztechapps/customer.common'
import { TooltipPopOver } from '@ztechapps/webui.util'

const query = buildUpdateCustomerCompanyNameQuery()

export const CustomerCompanyNameInlineInput = ({ customer }: { customer: Customer }) => {
  return (
    <CustomerInlineInput
      query={'company {_id name }'}
      mutationConfig={{ query }}
      initialValues={customer}
      name="company.name"
      emptyContent={<p className="text-info font-italic"> Click here to add company name.</p>}
      displayContent={(e) => (
        <TooltipPopOver tooltipBody="Company name">
          <p>
            <i className="fa fa-address-card" /> {e}
          </p>
        </TooltipPopOver>
      )}
      updateParams={({ updatedValue, _id }) => {
        return {
          input: {
            _id,
            companyName: updatedValue,
            customerId: _id,
          },
        }
      }}
    />
  )
}
